import { createContext, useState } from 'react';
import Toaster, { ToastConfig } from '../components/Toaster';

interface ToasterContextProps {
  children: React.ReactNode;
}

interface ToasterContextValue {
  showToast: (config: ToastConfig) => void;
  onClose: () => void;
}

const ToasterContext = createContext<ToasterContextValue | null>(null);

const ToasterProvider: React.FC<ToasterContextProps> = ({ children }) => {
  const [toastConfig, setToastConfig] = useState<ToastConfig | null>(null);
  const [show, setShow] = useState(false);

  const showToast = (config: ToastConfig) => {
    setToastConfig(config);
    setShow(true);
  };

  const onClose = () => {
    setShow(false);
  };

  return (
    <ToasterContext.Provider value={{ showToast, onClose }}>
      {children}
      {toastConfig && (
        <Toaster
          show={show}
          onClose={onClose}
          type={toastConfig.type}
          title={toastConfig.title}
          message={toastConfig.message}
          icon={toastConfig.icon}
        />
      )}
    </ToasterContext.Provider>
  );
};

export { ToasterProvider, ToasterContext };